<template>
  <div class="row">
    <div class="col-12 mb-2">
      <h4 class="mb-0">Acompanhar</h4>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6 col-xl-3 mb-3">
      <router-link to="/distributions" title="Distribuições">
        <button
          type="button"
          class="btn btn-light bg-white w-100 flex-column rounded py-2"
        >
          <i class="ph ph-paper-plane-tilt text-teal ph-2x mb-1" />
          Distribuições
        </button>
      </router-link>
    </div>
    <div class="col-sm-6 col-xl-3 mb-3">
      <router-link to="/reports/generals" title="Relatório Geral">
        <button
          type="button"
          class="btn btn-light bg-white w-100 flex-column rounded py-2"
        >
          <i class="ph ph-presentation-chart text-indigo ph-2x mb-1" />
          Relatório Geral
        </button>
      </router-link>
    </div>
    <div class="col-sm-6 col-xl-3 mb-3">
      <router-link to="/reports/grip" title="Relatório de Aderência">
        <button
          type="button"
          class="btn btn-light bg-white w-100 flex-column rounded py-2"
        >
          <i class="ph ph-chart-pie text-pink ph-2x mb-1" />
          Relatório Aderência
        </button>
      </router-link>
    </div>
  </div>
  <div class="row">
    <div class="col-12 mb-2">
      <h4 class="mb-0">Parametrizações</h4>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6 col-xl-3 mb-3">
      <router-link to="/params/boards" title="Quadros">
        <button
          type="button"
          class="btn btn-light bg-white w-100 flex-column rounded py-2"
        >
          <i class="ph ph-chalkboard-teacher text-purple ph-2x mb-1" />
          Quadros
        </button>
      </router-link>
    </div>
    <div class="col-sm-6 col-xl-3 mb-3">
      <router-link to="/params/groups" title="Grupos">
        <button
          type="button"
          class="btn btn-light bg-white w-100 flex-column rounded py-2"
        >
          <i class="ph ph-bounding-box text-purple ph-2x mb-1" />
          Grupos
        </button>
      </router-link>
    </div>
    <div class="col-sm-6 col-xl-3 mb-3">
      <router-link to="/params/surveys" title="Pesquisas">
        <button
          type="button"
          class="btn btn-light bg-white w-100 flex-column rounded py-2"
        >
          <i class="ph ph-seal-question text-primary ph-2x mb-1" />
          Pesquisas
        </button>
      </router-link>
    </div>
    <div class="col-sm-6 col-xl-3 mb-3">
      <router-link to="/params/distributions" title="Distribuições">
        <button
          type="button"
          class="btn btn-light bg-white w-100 flex-column rounded py-2"
        >
          <i class="ph ph-paper-plane text-primary ph-2x mb-1" />
          Distribuições
        </button>
      </router-link>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-xl-6">
      <div class="row">
        <div class="col-12 mb-2">
          <h4 class="mb-0">Registros</h4>
        </div>
        <div class="col-sm-6 col-xl-6 mb-3">
          <router-link to="/registers/tickets" title="Tickets">
            <button
              type="button"
              class="btn btn-light bg-white w-100 flex-column rounded py-2"
            >
              <i class="ph ph-ticket text-teal ph-2x mb-1" />
              Tickets
            </button>
          </router-link>
        </div>
        <div class="col-sm-6 col-xl-6 mb-3">
          <router-link to="/registers/contacts" title="Contatos">
            <button
              type="button"
              class="btn btn-light bg-white w-100 flex-column rounded py-2"
            >
              <i class="ph ph-user-list text-indigo ph-2x mb-1" />
              Contatos
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <div class="col-12 col-xl-6">
      <div class="row">
        <div class="col-12 mb-2">
          <h4 class="mb-0">Administração</h4>
        </div>
        <div class="col-sm-6 col-xl-6 mb-3">
          <router-link to="/admin/users" title="Gerenciar Usuários">
            <button
              type="button"
              class="btn btn-light bg-white w-100 flex-column rounded py-2"
            >
              <i class="ph ph-users text-secondary ph-2x mb-1" />
              Usuários
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
}
</script>
